import { PaginatedResult } from "@/interfaces/common/PaginatedResult";
import {
  Order,
  OrderFallbackContact,
  OrderItem,
  OrderPaymentDetails,
  OrderPaymentMethod,
  OrderRate,
  OrderVoucherDetails,
} from "@/interfaces/domain/Order";
import { api, image_path_stores } from "@/services/api";

export type CreateOrderPayload = {
  valor_total: number;
  cliente: string;
  endereco_cliente: string;
  estabelecimento: string;
  agendado?: boolean;
  dataAgendamento?: string;
  produtos_nao_encontrados?: string;
  metodo_pagamento: OrderPaymentMethod;
  detalhes_desconto?: OrderVoucherDetails<string>;
  detalhes_pagamento: OrderPaymentDetails;
  itens: OrderItem<string>[];
  opcao_falta_estoque: OrderFallbackContact;
};

export async function createOrder(payload: CreateOrderPayload) {
  const { data } = await api.post<Order>("/pedidos", payload);
  return data;
}

export async function getOrderById(orderId: string) {
  const { data } = await api.get<Order>(`/pedidos/${orderId}`);
  if (data && data.estabelecimento) {
    data.estabelecimento.foto_estabelecimento = `${image_path_stores}/${data.estabelecimento?.foto_estabelecimento}`;
  }
  return data;
}

export async function getClientOrders(clientId: string, page = 1): Promise<PaginatedResult<Order>> {
  const { data } = await api.get<PaginatedResult<Order>>(
    `/clientes/${clientId}/pedidos?page=${page}`
  );
  const formated = data?.docs?.map((order) => ({
    ...order,
    estabelecimento: {
      ...order.estabelecimento,
      foto_estabelecimento: `${image_path_stores}/${order.estabelecimento?.foto_estabelecimento}`,
    },
  }));
  data.docs = formated;
  return data;
}

export async function evaluateOrder(orderId: string, payload: OrderRate) {
  await api.post<Order>(`pedidos/${orderId}/avaliacao`, { avaliacao: payload });
}
